/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDetailsRequest } from './';
import {
    ProjectDetailsRequestFromJSON,
    ProjectDetailsRequestFromJSONTyped,
    ProjectDetailsRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectResponse
 */
export interface ProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectResponse
     */
    description: string;
    /**
     * 
     * @type {ProjectDetailsRequest}
     * @memberof ProjectResponse
     */
    details?: ProjectDetailsRequest;
}

/**
 * Check if a given object implements the ProjectResponse interface.
 */
export function instanceOfProjectResponse(value: object): value is ProjectResponse {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ProjectResponseFromJSON(json: any): ProjectResponse {
    return ProjectResponseFromJSONTyped(json, false);
}

export function ProjectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'details': json['details'] == null ? undefined : ProjectDetailsRequestFromJSON(json['details']),
    };
}

export function ProjectResponseToJSON(value?: ProjectResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'description': value['description'],
        'details': ProjectDetailsRequestToJSON(value['details']),
    };
}

